import type { Event } from '../types';
import type { EventDTO } from '../schemas';

export function mapEventDTOToDomain(dto: EventDTO): Event {
  const { details, ...core } = dto;
  return {
    ...core,
    ...(details || {}),
  } as Event;
}

export function mapEventsDTOToDomain(dtos: EventDTO[]): Event[] {
  return dtos.map(mapEventDTOToDomain);
}
